import { useRef } from 'react';
import { getPopularComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function PopularComics() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    }
  };

  const comics = getPopularComics();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <p className="text-xs text-foreground-500 font-medium uppercase tracking-wider">热门推荐</p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
              大家都在看
            </h2>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-500 hover:text-white transition-all cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-500 hover:text-white transition-all cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto scrollbar-hide pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {comics.map((comic) => (
            <div key={comic.id} className="flex-shrink-0 w-[160px] md:w-[200px]">
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}